// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"3b6fb836","787":"b2e1647c"}[chunkId] + ".chunk.js";
};